export default __webpack_public_path__ + "media/images/messaging-icon-82987956020ac9ebc50733e73d64732a.svg";